import { useEstabFormContext } from './Context';
import React from 'react';
import { ImageEstab } from './ImageEstab';
import { SettingsRow, SettingsSection } from './SettingsGroup';
import moment from 'moment-timezone';

const availableTimezones = moment.tz.names();

export function GeralEstabelecimento() {
    const { name, setName, imageId, setImageId, timezone, setTimezone } = useEstabFormContext();
    const timezoneOptions = availableTimezones.includes(timezone)
        ? availableTimezones
        : Array.from(new Set([...availableTimezones, timezone].filter(Boolean))).sort();

    return (
        <div className="grid gap-6 xl:grid-cols-2 xl:items-start">
            <SettingsSection title="Identidade" footer="O nome aparece para clientes na agenda e nas mensagens automáticas.">
                <SettingsRow label="Nome" htmlFor="name">
                    <input
                        type="text"
                        id="name"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        className="input estab-field"
                        placeholder="Nome do estabelecimento"
                        autoComplete="organization"
                    />
                </SettingsRow>
            </SettingsSection>

            <SettingsSection title="Fuso horário" footer="Selecione o fuso horário do estabelecimento. Alterar esta configuração não desloca os agendamentos já salvos. A agenda e as mensagens seguem o horário local do estabelecimento.">
                <SettingsRow label="Fuso horário" htmlFor="estab-timezone">
                    <select
                        id="estab-timezone"
                        value={timezone}
                        onChange={(event) => setTimezone(event.target.value)}
                        className="select estab-field"
                        required
                    >
                        {timezoneOptions.map((zone) => (
                            <option key={zone} value={zone}>
                                {zone.replace(/_/g, ' ')}
                            </option>
                        ))}
                    </select>
                </SettingsRow>
            </SettingsSection>

            <SettingsSection title="Logo" footer="Recomendado: imagem horizontal (ex.: 600x160) com fundo transparente.">
                <ImageEstab key={`${!!imageId.length}`} imageId={imageId} setImageId={setImageId} />
            </SettingsSection>
        </div>
    );
}
